<template>
  <div>
    <div class="item-hdr">
      <h3>{{title}}</h3>
      <div>
        <el-tooltip v-if="password && !showRawPassword" content="点击显示密码原文"><el-button size="mini" @click="showRawPasswordHandler" class="el-icon-lock" /></el-tooltip>
        <el-tooltip v-if="password && showRawPassword" content="点击显示加密后的密码"><el-button size="mini" @click="showEncryptedPasswordHandler" class="el-icon-unlock" /></el-tooltip>

        <el-tooltip v-if="!password" content="复制到粘贴板"><el-button size="mini" @click="copyHandler" class="el-icon-document-copy" /></el-tooltip>
        <el-tooltip v-if="!password && downloadFileName" content="下载"><el-button size="mini" @click="downloadHandler" class="el-icon-download" /></el-tooltip>
      </div>
    </div>
    <key v-show="!showRawPassword" :text="text" />
    <key v-show="showRawPassword" :text="rawPassword" />
  </div>
</template>

<script>
import key from "./key.vue"
export default {
  name: "keyWithTool",
  props: {
    title: String,
    text: String,
    downloadFileName: String, // 不指定则不显示下载按钮
    password: Boolean, // 是否为密码, 如果是的话则以密码的形式显示, 设置为 password === true 时, text 应为加密后的密码
  },
  data() {
    return {
      showRawPassword: false,
      rawPassword: "",
    }
  },
  components: {
    key,
  },
  watch: {
    text: function() {
      this.rawPassword = ""
    }
  },
  methods: {
    copyHandler: function() {
      this.utils.copyToClipboard(this.text)
      this.$message.success("已复制到粘贴板")
    },
    downloadHandler: function() {
      this.utils.downloadText(this.downloadFileName, this.text)
    },
    showRawPasswordHandler: function() {
      this.showRawPassword = true

      if (!this.rawPassword) {
        let self = this
        let opts = {
          'encryptedPassword': this.text // String | 加密后的字符串
        };
        this.api.sess.getSessionPasswordDecrypted(opts, (error, data, response) => {
          if (error) {
            self.api.errHandler(self, error, response)
          } else {
            self.rawPassword = data
          }
        })
      }
    },
    showEncryptedPasswordHandler: function() {
      this.showRawPassword = false
    },
  },
}
</script>

<style scoped>
.item-hdr {
  display: flex;
  justify-content: space-between;
}
</style>
